import {reactive} from "vue";

const toasts = {
    data: reactive({
        toasts: []
    }),
    timer() {
        toasts.data.toasts = toasts.data.toasts.filter(toast => toast.expiresAt === undefined || toast.expiresAt === null || Date.now() < toast.expiresAt);
    },
    create: (options) => {
        const id = Math.random();
        const toast = {
            id: id,
            options: options,
            expiresAt: Date.now() + (options.duration ? options.duration : 5000),
            remove: () => {
                toasts.data.toasts = toasts.data.toasts.filter(item => item.id !== id);
            }
        }
        toasts.data.toasts.unshift(toast);
    },
};

export default toasts;
